import { render, staticRenderFns } from "./Fenye.vue?vue&type=template&id=d3036f4e"
import script from "./Fenye.vue?vue&type=script&lang=js"
export * from "./Fenye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports